import { render, staticRenderFns } from "./PublicQuotationPages4.vue?vue&type=template&id=211f2aa8&scoped=true&"
import script from "./PublicQuotationPages4.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f2aa8",
  null
  
)

export default component.exports